import { action } from '@ember/object';
import Component from '@glimmer/component';

import type { GoalTargetSuccessCondition } from 'webapp/enums/enums';

import FormSelectComponent from 'webapp/components/form/select';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

import type { Goal } from 'webapp/models-custom';

export interface Args {
	model: Goal;
	onChange: (value: GoalTargetSuccessCondition) => void;
	submitInProgress?: boolean;
}

export default class GoalSuccessConditionComponent extends Component<Args> {
	get model() {
		return this.args.model;
	}

	get isDisabled() {
		return this.args.submitInProgress || this.model.historyValuesOverride;
	}

	get showDisabledTooltip() {
		return !this.model.timeframe && !this.model.endDate;
	}

	@action
	change(value: GoalTargetSuccessCondition) {
		this.args.onChange(value);
	}

	// fake grow by when percentages are chosen
	fakeGrowByValue = 99;
	fakeGrowByOptions = [{ value: this.fakeGrowByValue, label: 'I want to grow by' }];

	get showFakeGrowBySelect() {
		// just for the looks, bcos its disabled
		// and does not actually change GoalTargetSuccessCondition on model in any way
		return this.model.isTargetValuePercentFormat;
	}

	@action
	changeFakeGrowBy() {
		// no. we don't change anything
	}
	<template>
		<div class="select-dropdown">
			{{#if this.showFakeGrowBySelect}}
				<FormSelectComponent
					name="successCondition"
					@selected={{this.fakeGrowByValue}}
					@options={{this.fakeGrowByOptions}}
					@onChange={{this.changeFakeGrowBy}}
					@isDisabled={{true}}
					@size="big"
				/>
			{{else}}
				<FormSelectComponent
					name="successCondition"
					@selected={{this.model.targetSuccessCondition}}
					@options={{this.model.successConditionOptions}}
					@onChange={{this.change}}
					@isDisabled={{this.isDisabled}}
					@isRequired={{true}}
					@size="big"
				/>
			{{/if}}
			{{#if this.showDisabledTooltip}}
				<ToolTipWithIconComponent
					@text="Set a timeframe or end date to enable 'I want to reach' success condition."
					@maxWidth={{230}}
					@iconSize="sm"
				/>
			{{/if}}
		</div>
	</template>
}
